// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainMenu {
  display: flex;
  color: #e1e9fc;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0px 20px 34px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 15px;
  color: #495057;
  box-shadow: 0 1px 0 0 #dddbda;
}

.-Background-Color {
  width: 32px;
  height: 32px;
  padding: 5px;
  margin: 10px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
}
.-Background-Color:hover {
  background: #f1f1f1;
  cursor: pointer;
  color: #495057;
}

.st0 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #706e6b !important;
}

.closeIcon:hover {
  background: #f1f1f1;
  cursor: pointer;
  color: #495057;
}

.MuiTypography-body1 {
  font-family: "ToyotaTypeBook" !important;
}

.MuiChip-label {
  padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SideBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACF,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AACF;;AACA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAEJ;AADI;EACI,mBAAA;EACA,eAAA;EACA,cAAA;AAGR;;AAAE;EACE,kBAAA;EACA,kBAAA;EACA,wBAAA;AAGJ;;AAAI;EACI,mBAAA;EACA,eAAA;EACA,cAAA;AAGR;;AACA;EACE,wCAAA;AAEF;;AACA;EACE,uBAAA;AAEF","sourcesContent":[".mainMenu{\n    display: flex;\n  color: #e1e9fc;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 20px 0px 20px 34px;\n  list-style: none;\n  height: 60px;\n  text-decoration: none;\n  font-size: 15px;\n  color:#495057;\n  box-shadow: 0 1px 0 0 #dddbda;\n}\n.-Background-Color {\n    width: 32px;\n    height: 32px;\n    padding: 5px;\n    margin: 10px;\n    border-radius: 4px;\n    border: solid 1px #dddbda;\n    background-color: #ffffff;\n    &:hover {\n        background: #f1f1f1;\n        cursor: pointer;\n        color:#495057;\n      }\n  }\n  .st0 {\n    fill-rule: evenodd;\n    clip-rule: evenodd;\n    fill: #706e6b !important;\n}\n  .closeIcon{\n    &:hover {\n        background: #f1f1f1;\n        cursor: pointer;\n        color:#495057;\n      }\n  }\n\n.MuiTypography-body1{\n  font-family: \"ToyotaTypeBook\" !important;\n}\n\n.MuiChip-label{\n  padding:0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
